import { Row, Col } from 'react-bootstrap'

function PageTitle({ title, className, size }) {
  return (
    <Row className="page-title text-center">
      <Col className='page-title-col' md={12}>
        <span className={className} style={{ fontSize: size + 'px' }}>{ title }</span>
      </Col>
    </Row>
  )
}

export default PageTitle